import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { authService } from '../../services/auth';
import type { LoginCredentials } from '../../types/auth';

export const Login: React.FC = () => {
  const navigate = useNavigate();
  const [credentials, setCredentials] = useState<LoginCredentials>({
    email: '',
    password: ''
  });
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);

    try {
      await authService.login(credentials);
      navigate('/dashboard');
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Login failed');
    }
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setCredentials(prev => ({
      ...prev,
      [name]: value
    }));
  };

  return (
    <div className="auth-page">
      <div className="auth-container">
        <div className="auth-header">
          <div className="auth-brand">
            <img src="/img/icon-f.png" alt="Suvadi" className="auth-logo" />
            <h1 className="auth-title">
              <span className="tamil tamil-highlight">சு</span>
              <span className="tamil tamil-accent">வடி</span> Suvadi
            </h1>
          </div>
          <p className="auth-subtitle">Welcome back to your digital heritage</p>
        </div>

        <form className="auth-form" onSubmit={handleSubmit}>
          {error && (
            <div className="auth-error">
              <span className="auth-error-icon">⚠️</span>
              <span className="auth-error-message">{error}</span>
            </div>
          )}

          <div className="form-group">
            <label htmlFor="email" className="form-label">
              Email Address
            </label>
            <input
              type="email"
              id="email"
              name="email"
              value={credentials.email}
              onChange={handleInputChange}
              className="form-input"
              placeholder="Enter your email"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="password" className="form-label">
              Password
            </label>
            <input
              type="password"
              id="password"
              name="password"
              value={credentials.password}
              onChange={handleInputChange}
              className="form-input"
              placeholder="Enter your password"
              required
            />
          </div>

          <button
            type="submit"
            className="btn btn-primary btn-lg btn-block"
            style={{ width: '100%' }}
          >
            Sign In
          </button>

          <div className="auth-divider">
            <span className="auth-divider-text">or</span>
          </div>

          <button
            type="button"
            className="btn btn-secondary btn-lg btn-block"
            onClick={() => navigate('/register')}
            style={{ width: '100%' }}
          >
            Create New Account
          </button>

          <div className="auth-links">
            <a href="#" className="auth-link">
              Forgot your password?
            </a>
          </div>
        </form>

        <div className="auth-footer">
          <p className="auth-footer-text">
            By signing in, you agree to our{' '}
            <a href="#" className="auth-link">Terms of Service</a>
            {' '}and{' '}
            <a href="#" className="auth-link">Privacy Policy</a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;
